<template>
  <v-list class="my-0 py-0">
    <template v-for="(item, i) in menu">
    <v-list-item :key="i+'a'" @click="select(item)" :class="{'primary white--text': item.component === selected}">
        <v-list-item-title>
          <div class="item-lista">
            <v-icon :class="{icono: true, 'white--text': item.component === selected}" small>{{item.icon}}</v-icon>
            <span class="pl-3">{{item.text}}</span>
          </div>
        </v-list-item-title>
    </v-list-item>
    <v-divider :key="i+'b'"></v-divider>
    </template>
  </v-list>
</template>
<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => []
    },
    clickFn: {
      type: Function
    },
    selected: {
      type: String
    }
  },
  methods: {
    select(item) {
      this.clickFn(item)
    }
  },
}
</script>
<style scoped>
.item-lista {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
}
</style>
